// ==============================|| OVERRIDES - LIST ITEM ICON ||============================== //

export default function FormHelperText(theme) {
  return {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: "14px",
        },
        label: {
          ...theme.typography.p2,
        },
      },
    },
  };
}
